import { AuthType, SSOOption } from '../../types';
import { isInIframe } from '@zapier/identity-utils';

export function shouldShowSSOOption(
  authType: AuthType | undefined,
  expectedSSOOption: SSOOption,
  forceLoginDisplayForm = true,
  ssoOptionEnabled?: boolean
) {
  // If we're in an iframe, Facebook is the only one that works.
  if (isInIframe() && expectedSSOOption !== 'facebook') {
    return false;
  }

  // No previous authentication type detected, or the user has indicated that they'd
  // like to see all available login options. Render all enabled SSO options.
  if (!authType || forceLoginDisplayForm) {
    return ssoOptionEnabled === undefined || ssoOptionEnabled === true;
  }

  // We've detected a previous auth type, render it.
  return (
    (ssoOptionEnabled === undefined || ssoOptionEnabled === true) &&
    authType === expectedSSOOption
  );
}
